import ResilientImage from './ResilientImage';

export default ResilientImage;
